import { FetchStatus } from '@server/fetch_status.type';
import type { CrmOrg } from '../../types/CrmOrgs';

export const shouldReconnectEnv = (crmOrg: CrmOrg) =>
  (crmOrg.fetchStatus === FetchStatus.Error && crmOrg.lastFetchedAt === null) ||
  crmOrg.fetchStatus === FetchStatus.InvalidCredentials;
